// No need to match package structure, to force compile time switch of dependencies
class PreProdFlavor : Flavor {
    override val clientName: String = "Linx-PreProd"
    override val adminClientName: String = "Admin Portal-PreProd"
    override val clientUrl: String = "linx-preprod.enrollandpay.com"
    override val serverHttps: Boolean = true
    override val environmentName: String = "PreProduction"
    override val serverUrl: String = "linx-prepro-west.wittywater-f46811a8.westus.azurecontainerapps.io"
    override val serviceServerUrl = "service-preprod.enrollandpay.com"
    override val serverPort: Int? = null
    override val serviceServerPort: Int? = null
    override val databaseConnectionString: String =
        "jdbc:sqlserver://enrollandpay.database.windows.net:1433;database=EnrollAndPayV2-PreProduction;encrypt=true;trustServerCertificate=false;hostNameInCertificate=*.database.windows.net;loginTimeout=30;"
    override val serverBusConnectionString: String = "Endpoint=sb://enrollandpaypreproduction.servicebus.windows.net/;SharedAccessKeyName=RootManageSharedAccessKey;SharedAccessKey=elUF1DbKIIKNXUSPjMnhUnvURl+G3W9DaktYimSJeeI="
    override val enpTerminalServerHost: String = "https://enpterminalapi-preproduction.azurewebsites.net/"
    override val enpServiceServerHost: String = "https://enpserviceapi-preproduction.azurewebsites.net/"
    override val token: String = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbnZpcm9ubWVudCI6InByZXByb2QiLCJuYW1lIjoiZW5yb2xsYW5kcGF5In0.NPCzaC8s0Tly9FGtI-MkIvgl3oN2GxC-G4KcfUnn53g"
    override val serviceApiKey: String = "4fe3b6de-138e-4ba2-ae48-b178e86d8e76"
    override val hubspotAccessToken: String? = null
    override val hubspotClientSecret: String? = null
    override val inboundServiceApiKey: String? = "ab3c7f9b-6c5c-4d1c-b084-6a8c70cc667f"
    override val portalUrl = "https://preproduction-portal.enrollandpay.com/"
    override val coalitionUrl = "https://preproduction-coalition.enrollandpay.com/"
    override val isDebug: Boolean = false
    override val alternateAdminLink: String = "https://admin.enrollandpay.com"
    override val alternateAdminTitle: String = "Prod"
    override val testHarnessUrl: String = "https://sdk-preprod-west.jollydune-5d4663a1.westus.azurecontainerapps.io/"
    override val logSources: List<LogSource> = listOf(
        LogSource(label = "sdk-preprod-west", containerAppName = "sdk-preprod-west", workspaceId = "e6821234-d2f1-43c9-8b63-83e6854c28cc"),
        LogSource(label = "sdk-dejavoo-preprod-west", containerAppName = "sdk-dejavoo-preprod-west", workspaceId = "e6821234-d2f1-43c9-8b63-83e6854c28cc"),
    )
}